export interface PriceProps {
  clientInteractions: number;
  clientPercentage: number;
}

export const usePrice = ({
  clientInteractions,
  clientPercentage,
}: PriceProps) => {
  //Global Harded-Information (for voices and digital)
  const watson = {
    digital: {
      cost: 0.14, // reverted back to original AWA-183
      averageCost: 6.0, // changed as per AWA-141
      uniqueUsers: 0.8,
      successRate: 0.7,
      total: clientInteractions * (1 - clientPercentage),
    },
    voices: {
      cost: 0.23, // reverted back to original AWA-183
      averageCost: 6.0,
      uniqueUsers: 0.8,
      successRate: 0.7,
      total: clientInteractions * clientPercentage,
    },
  };

  //Create an object with all calculations made
  const allCalculations = (interaction: any) => {
    const mauNumber = interaction.total * interaction.uniqueUsers;
    const handleQtty = interaction.total * interaction.successRate;
    const handledCost = interaction.cost * mauNumber;
    const notHandleQtty = interaction.total - handleQtty;
    const notHandledCost = notHandleQtty * interaction.averageCost;

    return {
      mauNumber: mauNumber,
      handledCost: handledCost,
      handleQtty: handleQtty,
      notHandledCost: notHandledCost,
      notHandleQtty: notHandleQtty,
    };
  };

  const voicesCalculations = allCalculations(watson.voices);
  const digitalCalculations = allCalculations(watson.digital);

  //Calculate the interactions
  const interactionsCalculate = (
    watsonTrue: boolean,
    interaction: any,
    watson: any,
  ): number => {
    let result: number;
    if (watsonTrue) {
      result = watson.total * watson.averageCost;
    } else {
      result = interaction.handledCost + interaction.notHandledCost;
    }
    return result;
  };

  const PriceWithWatson =
    interactionsCalculate(true, voicesCalculations, watson.voices) +
    interactionsCalculate(true, digitalCalculations, watson.digital);

  const PriceWhithoutWatson =
    interactionsCalculate(false, voicesCalculations, watson.voices) +
    interactionsCalculate(false, digitalCalculations, watson.digital);

  const moneySaved = (time: string): number => {
    if (time === 'month') {
      return PriceWithWatson - PriceWhithoutWatson;
    }
    if (time === 'year') {
      return (PriceWithWatson - PriceWhithoutWatson) * 12;
    }
    return 0;
  };

  const savedPerMonth = Math.round(moneySaved('month'));
  const savedPerYear = Math.round(moneySaved('year'));

  return [savedPerMonth, savedPerYear];
};
